"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ListScreen_1 = __importDefault(require("./ListScreen"));
const ui_1 = require("@rahtab/ui");
const Button_1 = __importDefault(require("@rahtab/ui/dist/components/Button"));
const SignoutIcon_1 = __importDefault(require("@rahtab/ui/dist/icons/SignoutIcon"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const signoutNavButton = {
    title: 'خروج',
    svg: react_1.default.createElement(SignoutIcon_1.default, null),
};
function ProfileScreen(props) {
    const { loading, transparentLoading, data, onSignOut, navButtons, renderProfileCard } = props;
    const [signoutBtmSheetVisibility, setSignoutBtmSheetVisibility] = react_1.useState(false);
    const navigationButtons = [...navButtons, signoutNavButton];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.BottomSheet, { visible: signoutBtmSheetVisibility, onRequestClose: () => setSignoutBtmSheetVisibility(false) },
            react_1.default.createElement(react_native_1.View, { style: { alignItems: 'center', marginBottom: ui_1.getSpacing() } },
                react_1.default.createElement(SignoutIcon_1.default, { width: 100, height: 100, style: { marginBottom: ui_1.getSpacing() } }),
                react_1.default.createElement(ui_1.Text, { variant: "title", color: "primary" }, "\u062E\u0631\u0648\u062C \u0627\u0632 \u0628\u0631\u0646\u0627\u0645\u0647")),
            react_1.default.createElement(ui_1.Text, null, "\u0622\u06CC\u0627 \u0628\u0631\u0627\u06CC \u062E\u0631\u0648\u062C \u0627\u0632 \u0628\u0631\u0646\u0627\u0645\u0647 \u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u062F\u0627\u0631\u06CC\u062F\u061F"),
            react_1.default.createElement(react_native_1.View, { style: styles.rowView },
                react_1.default.createElement(Button_1.default, { color: "primary", variant: "outlined", text: "\u0628\u0627\u0632\u06AF\u0634\u062A", style: { marginTop: ui_1.getSpacing(), flex: 1 }, onPress: () => setSignoutBtmSheetVisibility(false) }),
                react_1.default.createElement(Button_1.default, { color: "primary", text: "\u062E\u0631\u0648\u062C", style: { marginTop: ui_1.getSpacing(), flex: 1.5, marginLeft: ui_1.getSpacing() }, onPress: () => {
                        onSignOut();
                        setSignoutBtmSheetVisibility(false);
                    } }))),
        react_1.default.createElement(ListScreen_1.default, { title: "\u062D\u0633\u0627\u0628 \u06A9\u0627\u0631\u0628\u0631\u06CC", loading: loading, transparentLoading: transparentLoading, data: data, listData: navigationButtons, renderControls: renderProfileCard, numColumns: 3, columnWrapperStyle: { paddingHorizontal: ui_1.getSpacing(0.5) }, keyExtractor: (_, index) => `buttons${index}`, renderItem: ({ item }) => (react_1.default.createElement(ui_1.ImageButton, { screenName: item.screenName, svg: item.svg, name: item.title, onPress: item.title === 'خروج' ? () => setSignoutBtmSheetVisibility(true) : undefined })) })));
}
exports.default = ProfileScreen;
const styles = react_native_1.StyleSheet.create({
    rowView: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    horizontalLine: {
        borderBottomWidth: ui_1.Shape.borderWidth,
        marginVertical: ui_1.getSpacing(),
        borderColor: ui_1.Colors.background,
    },
});
